import { useState } from 'react'
import {
  IconCheckCircle,
  IconCircleX,
  Badge,
  GreenGreen60,
  GreyGrey30,
  GreyGrey50,
  ShadowXs,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Box,
  Flex
} from '@sequencehq/core-components'
import { useContactTable } from './useContactTable'
import { EmptyContent } from './EmptyContent'
import { KebabMenu } from './KebabMenu'
import { EditContactModal } from 'CustomerContacts/view/modals/EditContactModal.tsx'
import { usePermissions } from 'lib/rbac'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import {
  isPrimaryBillingContact,
  isShippingContact,
  receivesBillingNotifications
} from 'CustomerContacts/utils/contactPurposes'

export const ContactTable = () => {
  const hook = useContactTable()
  const { can } = usePermissions()
  const { useCustomerShippingAddresses } = useFeatureFlags()
  const [editingContactId, setEditingContactId] = useState<string | null>(null)

  const { contacts } = hook

  return (
    <>
      <TableContainer
        data-testid="contacts.table"
        borderRadius="lg"
        overflow="hidden"
        border={`1px solid ${GreyGrey30}`}
        mt={2}
        width="100%"
        boxShadow={ShadowXs}
      >
        <Table variant="v2" width="100%">
          <Thead>
            <Tr>
              <Th>Email</Th>
              <Th>Name</Th>
              <Th>Receives invoices</Th>
              <Th></Th>
            </Tr>
          </Thead>

          <Tbody>
            {contacts.length === 0 && <EmptyContent />}

            {contacts.map(contact => (
              <Tr
                key={contact.id}
                data-testid={`contacts.row.${contact.id}`}
                onClick={() => {
                  if (can('org.customer:update')) {
                    hook.editContact.editContactById(contact.id)
                    setEditingContactId(contact.id)
                  }
                }}
              >
                <Td>{contact.email}</Td>
                <Td isTruncated>{contact.name}</Td>
                <Td style={{ width: '100%' }}>
                  {receivesBillingNotifications(contact) ? (
                    <IconCheckCircle color={GreenGreen60} />
                  ) : (
                    <IconCircleX color={GreyGrey50} />
                  )}
                </Td>
                <Td padding="0 8px !important">
                  <Flex alignItems="center" justifyContent="flex-end" gap="8px">
                    {isPrimaryBillingContact(contact) && (
                      <Badge
                        data-testid={`contacts.row.${contact.id}.primaryBadge`}
                      >
                        {useCustomerShippingAddresses ? 'Billing' : 'Primary'}
                      </Badge>
                    )}
                    {useCustomerShippingAddresses &&
                      isShippingContact(contact) && (
                        <Badge
                          data-testid={`contacts.row.${contact.id}.shippingBadge`}
                        >
                          Shipping
                        </Badge>
                      )}
                    <Box as="span" onClick={event => event.stopPropagation()}>
                      <KebabMenu contact={contact} hook={hook} />
                    </Box>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      {editingContactId && (
        <EditContactModal
          isOpen
          contactId={editingContactId}
          onClose={() => setEditingContactId(null)}
        />
      )}
    </>
  )
}
